import { useTranslation } from 'react-i18next';
import type { TppZipConnection } from '../../../services/transitPassPool.service';
import TppZipSessionBadge from './TppZipSessionBadge';

type Props = {
  zipConnected: boolean;
  zipConn: TppZipConnection | null;
  showGuestChip: boolean;
  onSwitchZip: () => void;
  onDownloadZip?: () => void;
  downloadPending?: boolean;
};

/** タイトル左・Zip 状態右（接続後も見出しを隠しすぎない） */
export default function TppPageHeader({
  zipConnected,
  zipConn,
  showGuestChip,
  onSwitchZip,
  onDownloadZip,
  downloadPending,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="mb-3 d-flex flex-wrap justify-content-between align-items-start gap-2">
      <div className="min-w-0">
        <h1 className="h3 fw-bold text-body mb-0">{t('tpp.title')}</h1>
        {!zipConnected ? (
          <p className="text-muted small mb-0 mt-1">{t('tpp.subtitle_disconnected')}</p>
        ) : null}
      </div>
      <TppZipSessionBadge
        zipConnected={zipConnected}
        zipConn={zipConn}
        showGuestChip={showGuestChip}
        onSwitchZip={onSwitchZip}
        onDownloadZip={onDownloadZip}
        downloadPending={downloadPending}
      />
    </div>
  );
}
